import React from "react";
import { NavDropdown } from "react-bootstrap";

const DropdownItemBase = ({ 
    icon, 
    text, 
    color, 
    titulo, 
    descricao, 
    subDescricao,
    dataFormatada, 
    onClick 
}) => {
    return (
        <NavDropdown.Item
            onClick={onClick}
            className="border-bottom py-2"
        >
            <div className="d-flex align-items-start">
                <div className={`me-2 mt-1 ${text}`}>
                    {React.cloneElement(icon, { size: 16 })}
                </div>
                <div>
                    <small className="d-block fw-bold text-dark">{titulo}</small>
                    <span className="d-block small text-muted">
                        {descricao}
                    </span>
                    {subDescricao && (
                        <span className="d-block small text-muted">
                            {subDescricao}
                        </span>
                    )}
                    {dataFormatada && (
                        <div style={{ fontSize: "0.8rem", color: "#777" }}>
                            {dataFormatada}
                        </div>
                    )}
                </div>
            </div>
        </NavDropdown.Item>
    );
};

export default DropdownItemBase;
